// Forms are listed as Intl plural categories in order: "one|other" for two-form
// languages, "one|few|many" for Polish. French takes the singular for 0, Polish "many".
export const pluralFormIndex = (count, formsCount, language) => {
  if (formsCount === 1) return 0;

  const category = new Intl.PluralRules(language).select(count);

  if (formsCount === 2) return category === "one" ? 0 : 1;
  if (category === "one") return 0;
  if (category === "few") return 1;
  return 2;
};
